import { ModelBase, observable } from "@shoothill/core";
import { IsNotEmpty, IsNumber, Max, Min } from "class-validator";
import { action } from "mobx";

export class DailyProgrammeProgressUpdateV2ItemModel extends ModelBase<DailyProgrammeProgressUpdateV2ItemModel> {
    @observable id: string | null = null;
    @observable dailyProgrammeProgressUpdateV2Id: string | null = null;

    @observable
    @IsNotEmpty({ message: "Trade is required" })
    public trade: string = "";

    @observable
    @IsNotEmpty({ message: "Activity is required" })
    public activity: string = "";

    @observable
    @IsNotEmpty({ message: "% completion is required" })
    @IsNumber({}, { message: "% completion must be a number" })
    @Min(0, { message: "% cannot be less than 0" })
    @Max(100, { message: "% cannot be more than 100" })
    public percentageCompletion: string = "";

    @observable createdByUserId: string | null = null;
    @observable createdDate: string | null = null;
    @observable lastUpdatedByUserId: string | null = null;
    @observable lastUpdatedDate: string | null = null;
    @observable rowVersion: string | null = null;

    @action
    fromDto(dto: DailyProgrammeProgressUpdateV2ItemDTO) {
        this.id = dto.id;
        this.dailyProgrammeProgressUpdateV2Id = dto.dailyProgrammeProgressUpdateV2Id;
        this.trade = dto.trade;
        this.activity = dto.activity;
        this.percentageCompletion = dto.percentageCompletion;
        this.createdByUserId = dto.createdByUserId;
        this.createdDate = dto.createdDate;
        this.lastUpdatedByUserId = dto.lastUpdatedByUserId;
        this.lastUpdatedDate = dto.lastUpdatedDate;
        this.rowVersion = dto.rowVersion;
    }

    toDto(): DailyProgrammeProgressUpdateV2ItemDTO {
        return {
            id: this.id,
            dailyProgrammeProgressUpdateV2Id: this.dailyProgrammeProgressUpdateV2Id,
            trade: this.trade,
            activity: this.activity,
            percentageCompletion: this.percentageCompletion!,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            lastUpdatedDate: this.lastUpdatedDate,
            rowVersion: this.rowVersion,
        };
    }
}

export interface DailyProgrammeProgressUpdateV2ItemDTO {
    id: string | null;
    dailyProgrammeProgressUpdateV2Id: string | null;
    trade: string;
    activity: string;
    percentageCompletion: string;
    createdByUserId: string | null;
    createdDate: string | null;
    lastUpdatedByUserId: string | null;
    lastUpdatedDate: string | null;
    rowVersion: string | null;
}
